module.exports = __webpack_public_path__ + "img/Wintersonne.7c6d53be.svg";